import { useTranslation } from "react-i18next";
import { api } from "convex/_generated/api";
import { useWorkspaceQuery } from "@/hooks/use-workspace-query";
import { useWorkspaceId } from "@/hooks/use-workspace-mutation";
import { useApiMutation } from "@/packages/features-shared";
import type { WorkspaceAuditTypeId } from "@/packages/types";

export interface WorkspaceAuditType {
  id: WorkspaceAuditTypeId;
  name: string;
  code: string;
  description: string | undefined;
}

export function useWorkspaceAuditTypes() {
  const { data, isLoading } = useWorkspaceQuery(
    api.workspace_audit_type_queries.listWorkspaceAuditTypes,
    {},
  );
  return { types: data as WorkspaceAuditType[] | undefined, isLoading };
}

export function useCreateWorkspaceAuditType() {
  const { t } = useTranslation("audits");
  const workspaceId = useWorkspaceId();
  const mutation = useApiMutation(
    api.workspace_audit_type_mutations.createWorkspaceAuditType,
    {
      name: "create-workspace-audit-type",
      successMessage: t("auditTypes.successCreate"),
    },
  );
  return {
    create: (args: { name: string; code: string; description?: string }) =>
      mutation.mutateAsync({
        ...args,
        workspaceId,
      }) as Promise<WorkspaceAuditTypeId>,
    isCreating: mutation.isPending,
  };
}
